// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Custom responsive utilities for better mobile experience */
@layer utilities {
  .xs\\:inline {
    @media (min-width: 475px) {
      display: inline;
    }
  }
  
  .xs\\:hidden {
    @media (min-width: 475px) {
      display: none;
    }
  }
  
  /* Touch-friendly tap targets */
  .touch-target {
    min-height: 44px;
    min-width: 44px;
  }
  
  /* Improved text readability on mobile */
  .mobile-text {
    line-height: 1.6;
    letter-spacing: 0.01em;
  }
  
  /* Better spacing for mobile cards */
  .mobile-card-spacing {
    @media (max-width: 640px) {
      margin-bottom: 1rem;
      padding: 1rem;
    }
  }
}

/* Custom scrollbar for better mobile experience */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Ensure proper touch scrolling on iOS */
* {
  -webkit-overflow-scrolling: touch;
}

/* Improve focus states for accessibility */
button:focus,
input:focus,
select:focus,
textarea:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Better mobile viewport handling */
@media (max-width: 640px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,6DAA6D;AAC7D;EACE;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA,+BAA+B;EAC/B;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,oCAAoC;EACpC;IACE;MACE,mBAAmB;MACnB,aAAa;IACf;EACF;AACF;;AAEA,kDAAkD;AAClD;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;AACnC;;AAEA,2CAA2C;AAC3C;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Custom responsive utilities for better mobile experience */\n@layer utilities {\n  .xs\\:inline {\n    @media (min-width: 475px) {\n      display: inline;\n    }\n  }\n  \n  .xs\\:hidden {\n    @media (min-width: 475px) {\n      display: none;\n    }\n  }\n  \n  /* Touch-friendly tap targets */\n  .touch-target {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  /* Improved text readability on mobile */\n  .mobile-text {\n    line-height: 1.6;\n    letter-spacing: 0.01em;\n  }\n  \n  /* Better spacing for mobile cards */\n  .mobile-card-spacing {\n    @media (max-width: 640px) {\n      margin-bottom: 1rem;\n      padding: 1rem;\n    }\n  }\n}\n\n/* Custom scrollbar for better mobile experience */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Ensure proper touch scrolling on iOS */\n* {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Improve focus states for accessibility */\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Better mobile viewport handling */\n@media (max-width: 640px) {\n  .container {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
